<app-navbar (pixelHeightChanged)="setTopMarginForNavbar($event)"></app-navbar>

<div class="container mt-4" [style]="'padding-top: ' + topMargin + 'px;'">
  <wm-renewal-details [registrationId]="registrationId"></wm-renewal-details>
</div>
